import React from 'react';
import { Heading, Paragraph } from '@zillow/constellation';

const UnsubscribeError = () => {
  return (
    <>
      <Heading level={2} as="h1" marginTop="lg" fontFamily="serif">
        We&apos;re sorry!
      </Heading>
      <Paragraph as="h3" marginTop="md">
        An unexpected error occurred while trying to update your email preferences. We will work to fix this
        expeditiously.
      </Paragraph>
    </>
  );
};

export default UnsubscribeError;
